import React, { useEffect, useCallback, useState} from 'react';
import {lstorage} from 'utils/lstorage.js';
import Tone from 'tone';
import Dropdown from 'react-dropdown';
import {connect} from 'react-redux';
import {
    LOWEST_SAMPLE_RATE,
    LOWER_SAMPLE_RATE,
    LOW_SAMPLE_RATE,
    MID_SAMPLE_RATE,
    HIGH_SAMPLE_RATE
} from 'constants/sample-rates.js';;

const SampeRateChooser = (props) => { 
    let [sampleRate, setSampleRate] = useState(props.sampleRate);
    let [needsReload, setNeedsReload] = useState(false);

    const onChange = useCallback((sampleRate) => {
        sampleRate = sampleRate.value;
        lstorage.setItem("sampleRate", sampleRate);
        setSampleRate(sampleRate);
        props.sequencerEngine.save("Test", "PUBLIC", false);
        setNeedsReload(true);
    }, [setSampleRate, needsReload]);

    return (
        <div className="sample-rate-chooser">
          <div className="dropdown-title">
            SampleRate:
          </div>
          <Dropdown
            className='audio-input-chooser-dropdown'
            controlClassName='audio-input-chooser-dropdown'
            arrowClassName='osc-type-arrow-dropdown'
            options={OPTIONS}
            onChange={onChange}
            value={getOption(sampleRate)}
            placeholder="Audio Input" />
          {needsReload ?
           <div className="needs-reload">
             Reload page to use new sample rate
           </div> : ''}
        </div>);
}

const OPTIONS = [
    LOWEST_SAMPLE_RATE, LOWER_SAMPLE_RATE, LOW_SAMPLE_RATE,
    MID_SAMPLE_RATE, HIGH_SAMPLE_RATE]
      .map(
          x => ({
              label: x,
              value: x
          }));

const getOption = (sampleRate) => ({
    label: sampleRate,
    value: sampleRate
});

const mapStateToProps = (state, props) => {
  return {
      sampleRate: props.sequencerEngine.context.sampleRate
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SampeRateChooser);
